import { LeagueNavRequestFormatter } from "../LeagueNavRequestFormatter";
import { LeagueNavResponseFormatter } from "../LeagueNavResponseFormatter";
import { BaseRequestResolver } from "../../../base";
export class LeagueNavRequestResolver extends BaseRequestResolver {
    constructor(options) {
        super({
            baseUrl: options.baseUrl,
            requestTimeout: options.requestTimeout,
            requestFormatter: new LeagueNavRequestFormatter(options),
            responseFormatter: new LeagueNavResponseFormatter(),
        });
    }
}
//# sourceMappingURL=LeagueNavRequestResolver.js.map